// The org this page is acting as, resolved once by AuthGuard before the router
// mounts. The slug in the URL (/o/<slug>/) is the source of truth; switching org
// changes the URL and reloads, so this is immutable for the life of the page.
//
// Side-effect free on purpose: api.ts reads it on every request and must not pull
// in the session store's localStorage access to do so.

let activeOrg: { slug: string; orgId: string } | null = null;

export function setActiveOrgState(slug: string, orgId: string): void {
  activeOrg = { slug, orgId };
}

export function clearActiveOrgState(): void {
  activeOrg = null;
}

export function getActiveOrgSlug(): string | null {
  return activeOrg?.slug ?? null;
}

export function getActiveOrgId(): string | null {
  return activeOrg?.orgId ?? null;
}
